module.exports = __webpack_public_path__ + "img/chess-rook.ac2b52d5.svg";